import { AuditLogEntity } from "domain/entity/AuditLog/AuditLogEntity";
import { AuditLogSearchCriteria } from "domain/entity/AuditLog/AuditLogSearchCriteria";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { AuditLogRepository } from "./AuditLogRepo";

/**
 * For template
 * @returns 
 */
export const AuditLogRepoImpl = (): AuditLogRepository => {
    const url = '/v1/auditLogSearch';

    const getEntities = (request: AuditLogSearchCriteria): Promise<AuditLogEntity[]> => {
        return axiosPostData(referenceAxiosInstance, url, request).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    return {
        getEntities: getEntities
    }
}